<template>
    <section id="application-data" class="pb-4">

        <div key="resultsKey" class="container" v-if="showResults">

            <div class="col-lg-12" data-aos="fade-up">
               
                <div class="row justify-content-center">
                    <div class="d-none d-lg-block col text-right row-style">
                    </div>
                    <div class="col-6 col-lg-4 text-left text-lg-center compare-style compare-style-top d-flex justify-content-start justify-content-lg-center align-items-end">
                        Competitive Model
                    </div>
                    <div class="col-6 col-lg-4 text-left text-lg-center oem-style oem-style-top d-flex justify-content-start justify-content-lg-center align-items-end">
                        <img src="~@/assets/img/logos/BradfordWhite_NoCaption_Logo.png" />
                    </div>
                </div>
                <div v-for="(value, index) in results" :key="value.propertyName+value.highlightColor" class="row justify-content-end">

                    <div class="d-none d-lg-block col text-right row-style prop-style"
                         :class="{ 'highlight-border-left-style': showLeftBorder(value.highlightColor),
                                   'highlight-border-bottom-style': showBottomBorder(value.highlightColor, index) }">
                        {{ value.caption | Trim }}
                    </div>

                    <template v-if="index == Object.keys(results).map(itm => results[itm]).length - 1">
                        <div class="col-6 col-lg-4 text-left text-lg-center row-style compare-style oem-style-bottom"
                             :class="{ 'highlight-style': showHighlightStyle(value.highlightColor),
                                       'highlight-border-left-style': showLeftBorder(value.highlightColor),
                                       'highlight-border-bottom-style': showBottomBorder(value.highlightColor, index) }"
                             :style="{ 'background-color': getHighlightColor(value.highlightColor) }">
                            <div class="d-lg-none row justify-content-start text-left prop-style-mobile">
                                {{ value.caption | Trim }}
                            </div>
                            <div class="row justify-content-start justify-content-lg-center">
                                {{ value.competitorModelValue }}
                            </div>
                        </div>
                        <div v-if="value.bradfordWhiteModelValue != '-'" class="col-6 col-lg-4 text-left text-lg-center row-style oem-style oem-style-bottom"
                             :class="{ 'highlight-style': showHighlightStyle(value.highlightColor),
                                       'highlight-border-left-style': showLeftBorder(value.highlightColor),
                                       'highlight-border-bottom-style': showBottomBorder(value.highlightColor, index) }"
                             :style="{ 'background-color': getHighlightColor(value.highlightColor) }">
                            <div class="d-lg-none row justify-content-start text-left prop-style-mobile">
                                &nbsp;
                            </div>
                            <div v-if="value.bradfordWhiteModelValue != '-'" class="row justify-content-start justify-content-lg-center text-break" v-html="value.bradfordWhiteModelValue"></div>
                        </div>
                        <div v-else class="col-6 col-lg-4 text-left text-lg-center row-style oem-style oem-style-bottom"></div>
                    </template>

                    <template v-else>
                        <div class="col-6 col-lg-4 text-left text-lg-center row-style compare-style"
                             :class="{ 'highlight-style': showHighlightStyle(value.highlightColor),
                                       'highlight-border-left-style': showLeftBorder(value.highlightColor),
                                       'highlight-border-bottom-style': showBottomBorder(value.highlightColor, index) }"
                             :style="{ 'background-color': getHighlightColor(value.highlightColor) }">
                            <div class="d-lg-none row justify-content-start text-left prop-style-mobile">
                                {{ value.caption | Trim }}
                            </div>
                            <div class="row justify-content-start justify-content-lg-center">

                                <div :class="{'font-weight-bold': value.propertyName == NAME_MODELNUMBER, 'text-md': value.propertyName == NAME_MODELNUMBER }">
                                    {{ value.competitorModelValue }}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-lg-4 text-left text-lg-center row-style oem-style"
                             :class="{ 'highlight-style': showHighlightStyle(value.highlightColor),
                                       'highlight-border-left-style': showLeftBorder(value.highlightColor, isNoMatch),
                                       'highlight-border-bottom-style': showBottomBorder(value.highlightColor, index, isNoMatch),
                                       'border-bottom-style' : value.bradfordWhiteModelValue != '-' }"
                             :style="{ 'background-color': getHighlightColor(value.highlightColor) }">
                            <div class="d-lg-none row justify-content-start text-left prop-style-mobile">
                                &nbsp;
                            </div>
                            <div class="row justify-content-start justify-content-lg-center" :class="{'text-md': value.propertyName == NAME_MODELNUMBER}">
                                <div v-if="value.propertyName == NAME_MODELNUMBER && value.bradfordWhiteModelDocuments && value.bradfordWhiteModelValue != '-'">
                                    <div v-if="value.bradfordWhiteModelDocuments.length < 2 && value.bradfordWhiteModelDocuments[0]">

                                        <a class="document-link font-weight-bold"
                                           :title="value.bradfordWhiteModelDocuments[0].title"
                                           :href="value.bradfordWhiteModelDocuments[0].url" target="_blank">
                                            {{ value.bradfordWhiteModelValue }}<i class="pl-2 fa fa-file icon-file-link"></i>
                                        </a>
                                    </div>
                                    <div v-else>
                                        <div class="font-weight-bold">
                                            {{ value.bradfordWhiteModelValue }}
                                        </div>
                                        <div v-for="document in value.bradfordWhiteModelDocuments" v-bind:key="document.title">
                                            <a class="document-link document-link-multi"
                                               :title="document.title"
                                               :href="document.url" target="_blank">
                                                <i class="mr-1 fa fa-file icon-file-link"></i>{{ document.title }}
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div :class="{'font-weight-bold': value.propertyName == NAME_MODELNUMBER }">
                                        <div v-if="value.bradfordWhiteModelValue == '-'" :style=" results.length < 14 ? `min-height: ${calcMinHeight()}px;` : '' ">
                                            <div v-if="value.propertyName == NAME_MODELNUMBER" class="text-sm text-left font-weight-normal position-absolute width-100 m-2" style="z-index: 1000; left: 0; top: 0;">
                                                <div class="row col text-center justify-content-center h3"><i class="mt-1 fa fa-exclamation-circle text-white"></i></div>

                                                In order for us to provide you with an appropriate recommendation please be ready to provide us with the following information:
                                                <ul class="mt-3 pl-3">
                                                    <li>Is this water heater in a residential or commercial application?</li>
                                                    <li>Any critical dimensions we should be aware of?</li>
                                                    <li>
                                                        New construction or replacement?
                                                        <ul class="pl-3">
                                                            <li>If new construction, please provide a fixture count and anticipated usage patterns.</li>
                                                            <li>If a replacement, has the existing water heater been able to keep up with the hot water demand?</li>
                                                        </ul>
                                                    </li>
                                                </ul>

                                                Once you have this information please reach out to the Bradford White Product Department at <a class="text-white font-weight-bold" href="mailto:products@bradfordwhite.com">products@bradfordwhite.com</a> or call <span class="font-weight-bold">844-235-4958</span> for assistance.
                                            </div>
                                        </div>
                                        <div v-else>
                                            {{ value.bradfordWhiteModelValue }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <div key="noResultsKey" class="container py-5 mb-4" v-else-if="showError">
            <div class="col-lg-12 text-left" data-aos="fade-in">
                <div class="row justify-content-center align-items-center">
                    <div class="col-auto">
                        <i class="mdi mdi-alert-circle-outline text-danger icon-style"></i>
                    </div>
                    <div class="col-8">
                        <div class="row h4 font-weight-bold">
                            Error Occurred
                        </div>
                        <div class="row">
                            Sorry, an error seems to have occurred while trying to fetch data for comparison. Please check your network connection and try again.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import smoothReflow from 'vue-smooth-reflow'    
    import * as constants from '@/utils/constants'

    export default {
        mixins: [smoothReflow],
        name: 'xref-results',
        props: {
            showResults: Boolean,
            showError: Boolean,
            results: Array,
        },
        methods: {
            async getPDF() {

            },
            getHighlightColor(highlightColor) {
                switch (highlightColor) {
                    case "IBRHighlight":
                        return this.highlightColors.IBR
                    case "DOEHighlight":
                        return this.highlightColors.DOE
                    case "NotesHighlight":
                        return this.highlightColors.Notes
                    case "ConnectionHighlight":
                        return this.highlightColors.Connection
                }
            },
            showHighlightStyle(highlightColor) {
                if (highlightColor
                    && highlightColor == "NotesHighlight") {
                    return true
                }
                return false
            },
            showLeftBorder(highlightColor, isNoMatch) {
                if (isNoMatch)
                    return false

                if (highlightColor
                    && highlightColor != "NotesHighlight"
                    && highlightColor != "ConnectionHighlight") {
                    return true
                }
                else {
                    return false
                }
            },
            showBottomBorder(highlightColor, index, isNoMatch) {
                if (isNoMatch)
                    return false

                var nextIndex = index + 1
                if (this.results[nextIndex]) {
                    var lastHighlightColor = this.results[nextIndex].highlightColor
                    if (highlightColor != lastHighlightColor
                        && highlightColor != "NotesHighlight"
                        && lastHighlightColor != "NotesHighlight"
                        && highlightColor != 'ConnectionHighlight'
                        && lastHighlightColor != "ConnectionHighlight") {
                        return true
                    }
                }
                return false
            },
            calcMinHeight() {

                var absoluteMinHeight = 230
                var calculatedMinHeight = 475 / this.results.length
                var result

                result = calculatedMinHeight
                if (calculatedMinHeight < absoluteMinHeight) { result = absoluteMinHeight }

                return result

                /*return 475 / this.results.length*/
            },
        },
        computed: {            
            isNoMatch() {
                if (this.results && this.results[0].bradfordWhiteModelValue == '-')
                    return true
                return false
            }
        },
        data() {
            return {
                NAME_MODELNUMBER: constants.NAME_MODELNUMBER,

                highlightColors: {
                    //IBR: "#ebebeb",
                    //DOE: "#dbffa6",
                    Notes: "#ffffe0",
                    //Connection: "#d1f8ff"
                },
                //showNote1: false,
                //showNote2: false,
            }
        },
        filters: {
            Trim(value) {
                return value.trim()
            },
            Empty(value) {
                if (value == null || value == "" || value == "-")
                    return "No Match"
                else
                    return value
            }

        },
        mounted() {
            this.$smoothReflow()
        },
    }
</script>
<style scoped lang="scss">
    @import '~@/styles/scss/variables';

   
    img {
        max-width: 100%;
    }

    .icon-style {
        font-size: 3.5rem;
    }

    .document-link-multi {
        font-size: $font-size-xs;
    }

    .highlight-style {
        color: $gray-700 !important;
    }

    .highlight-border-left-style {
        border-left: 1px $default solid !important;
    }

    .highlight-border-top-style {
        border-top: 1px $default solid !important;
    }

    .highlight-border-bottom-style {
        border-bottom: 1px $default solid !important;
    }

    .row-style {
        font-size: $font-size-sm;
        margin: 0;
        padding: 5px 20px;
        /*border-bottom: 1px $gray-200 solid;*/
    }

    .prop-style-mobile {
        color: $default;
        font-weight: bold;
        font-size: $font-size-md;
        margin-bottom: 5px;
    }

    .prop-style {
        color: $default;
        font-weight: bold;
        /*border-left: 1px $gray-200 solid;*/
        /*border-bottom: 1px $gray-200 solid;*/
    }

    .compare-style {
        color: $gray-800;
        border-left: 1px $default solid;
        border-bottom: 1px $gray-400 solid;
        background-color: $gray-100;
        /*font-weight: bold;*/
    }

    .border-bottom-style {
        border-bottom: 1px $gray-400 solid;
    }

    .oem-style {
        border-left: 1px $default solid;
        border-right: 1px $default solid;
        /*border-bottom: 1px $gray-400 solid;*/
        background-color: #6685a2;
        color: white;
        /*font-weight: bold;*/
    }

    .compare-style-top, .oem-style-top {
        border-top: 1px $default solid;
        font-size: $font-size-lg;
        padding: 10px 5px;
        font-weight: bold;
    }

    .compare-style-top {
        border-bottom: 1px $default solid;
    }

    .oem-style-top {
        background-color: $default;
        border-bottom: 1px $default solid;
    }

    .compare-style-bottom {
        border-bottom: 1px $default solid;
    }

    .oem-style-bottom {
        border-bottom: 1px $default solid;
    }
</style>
